
import React, { useState } from "react";
import { useRoleVerify } from "Common/RoleVerify";
import {
  GetAll,
  Delete
} from "adminApi/CustomersApi/WakeUpCall";
import DataTable from "Common/DataTable/DataTable";
import useDebouncedValue from "Common/DataTable/useDebouncedValue";
import usePaginatedFetch from "Hooks/usePaginatedFetch";
import useTableConfig from "Hooks/useTableConfig";
import { generateDisplayFields } from "utils/fieldMapper";
import fields from "../../json/WakeUpCalllFields.json";

const WakeUpCallListTable = () => {
  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const debouncedSearch = useDebouncedValue(search, 500);
  const canShowAction = useRoleVerify("", ["can_edit", "can_delete"]);
  const sizeOptions = [10, 20, 50, 100];
  const {tabledata} = fields
  
  // Fetch Hook
  const { data, meta, loading, error, refetch } = usePaginatedFetch(GetAll, {
    page,
    limit,
    search: debouncedSearch,
    title: "Wake Up Call List",
  });

  const displayFields =generateDisplayFields(tabledata);

  const formattedDatas = () => {
    return data.map(item => {
      const date = new Date(item.wk_time);
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
  
      return {
        ...item,
        wk_time: `${hours}:${minutes} ${day}/${month}/${year}`
      };
    });
  };
  // Table Hook
  const { formattedData, columns } = useTableConfig({
    data:formattedDatas(),
    page,
    limit,
    canShowAction,
    refetch,
    IsDelete: true,
    config: {
      entityName: "Wake Up Call List",
      editUrl: "edit-wake-up-call",
      idKey: "wk_id",
      deleteApi: Delete,
      displayFields,
    },
  });

  const handleSearch = (val, resetPage = null) => {
    setSearch(val);
    if (resetPage !== null) setPage(resetPage);
  };

  const onPageChange = (p) => setPage(p);
  const onLimitChange = (newLimit) => {
    setLimit(newLimit);
    setPage(1);
  };

  return (
    <DataTable
      columns={columns}
      data={formattedData}
      options={{
        loading,
        error,
        sortableColumns: displayFields.map((f) => f.accessor),
        copy: true,
        csv: true,
        pdf: true,
        print: true,
        fileName: "Wake Up Call",
      }}
      Search={{
        search: true,
        SearchInputValue: search,
        handleSearch: handleSearch,
      }}
      Entries={{
        Entries: true,
        limit,
        onLimitChange,
        options: sizeOptions,
      }}
      pagination={{
        isActive: true,
        meta,
        onPageChange,
      }}
    />
  );
};

export default WakeUpCallListTable;
